import angular from 'angular';
import assetSupplierFields from './assetSupplierFields';

export default angular
  .module('components.assetSupplierFields', [])
  .component('assetSupplierFields', assetSupplierFields).name;
